import React from 'react'
import EcommIcons from './EcommIcons'
import SocialIcon from './SocialIcon'

function Icons() {
    return (
        <div>
            <SocialIcon />
            <EcommIcons />
        </div>
    )
}

export default Icons
